import { useUser } from 'utils/hooks/useUser';
import { useMutation } from '@tanstack/react-query';
import { api } from 'api';

export const useHubAccountConfirmation = () => {
  const { id } = useUser();

  const { mutateAsync: confirmHubAccountExistence, isLoading } = useMutation({
    mutationFn: async () => {
      const { data } = await api.confirmHubAccountExistence(id);

      return data;
    },
  });

  return {
    confirmHubAccountExistence,
    isLoading,
  };
};
